import request from '@/util/http'



// 收藏列表查询
export const getCollectionList=(params)=>request({
    url: '/admin/personalCenter/collection/list',
    method: 'get',
    params
})
